import React, { useState } from 'react';
import './YouTubeTranscriptCard.css';

export default function YouTubeTranscriptCard({ onPasteToSplitter }) {
  const [url, setUrl] = useState('');
  const [transcript, setTranscript] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const extractYouTubeId = (url) => {
    const match = url.match(/(?:youtube\.com\/(?:.*v=|v\/|embed\/|shorts\/)|youtu\.be\/)([^&\n?#]+)/);
    return match ? match[1] : null;
  };

  const handleFetch = async () => {
    setLoading(true);
    setTranscript('');
    setError(null);

    try {
      const videoId = extractYouTubeId(url);
      if (!videoId) throw new Error('Invalid YouTube URL');

      const response = await fetch('https://prodpilot-eddjq2yr4-prodpilots-projects.vercel.app/api/transcript', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ videoId })
      });

      const data = await response.json();

      if (!response.ok) throw new Error(data.error || 'Error fetching transcript');

      const formatted = data.transcript
        .map((entry) => entry.text) // ❌ No timestamp
        .join('\n');

      setTranscript(formatted);
    } catch (err) {
      setError(err.message || 'Unknown error');
    }

    setLoading(false);
  };

  return (
    <div className="transcript-card">
      <h2>🎥 YouTube Transcript Fetcher</h2>
      <input
        type="text"
        value={url}
        placeholder="Paste YouTube URL here"
        onChange={(e) => setUrl(e.target.value)}
        className="transcript-input"
      />
      <button onClick={handleFetch} disabled={loading || !url} className="transcript-button">
        {loading ? 'Fetching...' : 'Get Transcript'}
      </button>

      {error && <p className="transcript-error">{error}</p>}

      {transcript && (
        <>
          <textarea rows="10" value={transcript} readOnly className="transcript-textarea" />
          <button onClick={() => onPasteToSplitter(transcript)} className="transcript-paste-button">
            Paste into Splitter
          </button>
        </>
      )}
    </div>
  );
}
